const CalculateBMI = (height, weight) => {
  if (!height || !weight) return {};
  const h2 = Math.pow(height / 100, 2);
  let value = weight / h2;
  // Bug real (auditoría 2026-08-16): el corte clínico estándar de "bajo peso" es IMC < 18.5,
  // no < 18 (mismo bug ya corregido en el módulo hermano App/EHR/V2/helpers.js#getBMI) — un
  // paciente con IMC entre 18.0 y 18.49 quedaba mal clasificado como "normal" y VitalSign.js
  // no mostraba el warning clínico correspondiente.
  if (value < 18.5) return { value, warning: "underweight" };
  if (value <= 25) return { value, warning: "normal" };
  if (value < 30) return { value, warning: "overweight" };
  return { value, warning: "obese" };
};

export default CalculateBMI;
